import { get, writable } from 'svelte/store';
import type { Company } from '$lib/types';

export const neighborSamples = writable<Company[]>([]);

/**
 * How many examples a similarity search takes.
 *
 * The API accepts ten and the sidebar's selector offered five; five is the
 * number kept, because it is the one customers have been shown. Both places
 * that collect samples now read it from here rather than writing `5` into a
 * comparison of their own.
 */
export const maxSamples = 5;

/**
 * Add one example, unless it is already there or the list is full.
 *
 * Returns whether it went in, so a caller can leave the search box open when
 * nothing happened rather than clearing it as though something did.
 */
export function addSample(company: Company): boolean {
  const current = get(neighborSamples);
  if (current.length >= maxSamples) return false;
  if (current.some((c) => c.id === company.id)) return false;

  neighborSamples.set([...current, company]);
  return true;
}

export function removeSample(id: string): void {
  neighborSamples.update((current) => current.filter((c) => c.id !== id));
}
